import {
  R_SERVICES,
  R_STATISTICAL_PROGRAMMING,
  R_CLINICAL_DATA_MANAGEMENT,
  R_MEDICAL_WRITING,
  R_REGULAR_AFFAIRS,
} from '../routes';

const Services = () => import(/* webpackChunkName: "Services" */ '@/views/Services');
const ServiceItem = () => import(/* webpackChunkName: "ServiceItem" */ '@/components/Services/ServiceItem');

export default {
  path: '/services',
  meta: {
    title: 'Services',
  },
  component: {
    render(c) {
      return c('router-view');
    },
  },
  children: [
    {
      name: R_SERVICES,
      path: '',
      meta: {
        title: 'Services',
      },
      component: Services,
    },
    {
      name: R_STATISTICAL_PROGRAMMING,
      path: 'statistical-programming',
      meta: {
        title: 'Services',
      },
      component: ServiceItem,
    },
    {
      name: R_CLINICAL_DATA_MANAGEMENT,
      path: 'clinical-data-management',
      meta: {
        title: 'Services',
      },
      component: ServiceItem,
    },
    {
      name: R_MEDICAL_WRITING,
      path: 'medical-writing',
      meta: {
        title: 'Services',
      },
      component: ServiceItem,
    },
    {
      name: R_REGULAR_AFFAIRS,
      path: 'regulatory-affairs',
      meta: {
        title: 'Services',
      },
      component: ServiceItem,
    },
  ],
};
